import { Site } from '@swf/core/enums';

import {
  TXTCLI_Confirm,
  TXTWCL_Confirm_your_break,
  TXTWCL_Confirm_your_self_exclusion,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_YouXll_be_able_to_request_to_r_ELL
} from './definitions.messages.json';

export enum ExclusionType {
  Break,
  Nationally,
  SelfExclusion,
  ShortTermDE,
  LongTermDE,
  PermanentSelfExclusion
}

export enum SelfExclusion {
  Brand,
  Nationally
}

export enum NationalExclusionVegasReasons {
  PreferNotToSay,
  GamblingAddiction,
  FinancialCommitments,
  HighDebts,
  SpendingOverBudget
}

export enum DeBreakType {
  None,
  LongTerm = 1,
  ShortTerm = 2
}

export interface FormValues {
  password: string;
  daysExclude?: number;
  daysExcludeNational?: number;
  nationalExclusionVegasReasons?: number[];
  nationalExclusionVegasPreferNotToSay?: boolean;
  nationalExclusionVegasIUnderstand?: boolean;
  longTermDE?: boolean;
  shortTermDE?: boolean;
  ssn4?: string;
}

export const exclusionSliderLimits = {
  [Site.UK]: [1, 42],
  [Site.FR]: [1, 365]
};

export const UKTakeABreakOptions: number[] = [1, 7, 30, 42];

export const exclusionTypeTimeouts = (site: Site, showVegasContent = false) => {
  switch (site) {
    case Site.USMI:
      return {
        [ExclusionType.Break]: [3, 7, 30, 60, 120, 180],
        [ExclusionType.SelfExclusion]: [365, 365 * 5]
      };
    case Site.UK:
      return {
        [ExclusionType.Break]: UKTakeABreakOptions.concat(
          Array(exclusionSliderLimits[Site.UK][1] - exclusionSliderLimits[Site.UK][0] + 1)
            .fill(0)
            .map((_, i) => i + 1)
        ),
        [ExclusionType.SelfExclusion]: [180, 365, 365 * 2, 365 * 3, 365 * 4, 365 * 5]
      };
    case Site.SE:
      return {
        [ExclusionType.Break]: [1, 7, 30, 60],
        [ExclusionType.SelfExclusion]: [120, 180, 0]
      };
    case Site.USPA:
      return {
        [ExclusionType.Break]: [3, 7, 30, 60, 120, 180],
        [ExclusionType.SelfExclusion]: []
      };
    case Site.USNJ:
      return {
        [ExclusionType.Break]: [3, 7, 30, 60, 120, 180],
        [ExclusionType.SelfExclusion]: [365, 365 * 5]
      };
    case Site.DESH:
      return {
        [ExclusionType.Break]: [1, 7, 30, 60, 120],
        [ExclusionType.SelfExclusion]: [180]
      };
    case Site.RO:
      return {
        [ExclusionType.Break]: [-12, 1],
        [ExclusionType.SelfExclusion]: [7, 30, 60, 120, 180]
      };
    case Site.COM:
    case Site.EU:
    case Site.NL:
      return !showVegasContent
        ? {
            [ExclusionType.Break]: [-12, 1, 7, 30, 60, 120, 180],
            [ExclusionType.SelfExclusion]: [365]
          }
        : {
            [ExclusionType.Break]: [-12, 1, 7, 30, 60, 120],
            [ExclusionType.SelfExclusion]: [180]
          };
    case Site.CAON:
      return {
        [ExclusionType.Break]: [1, 7, 30, 60, 90],
        [ExclusionType.SelfExclusion]: [180, 365, 365 * 5]
      };
    case Site.FR:
      return {
        [ExclusionType.Break]: [],
        [ExclusionType.SelfExclusion]: [1, 3, 5, 7, 15, 30, 45, 60, 90, 120, 180, 270, 365]
      };
    case Site.GR:
      return {
        [ExclusionType.Break]: [1],
        [ExclusionType.SelfExclusion]: [30],
        [ExclusionType.PermanentSelfExclusion]: [0]
      };
    default:
      return {
        [ExclusionType.Break]: [-12, 1, 7, 30, 60, 120],
        [ExclusionType.SelfExclusion]: [180]
      };
  }
};

export const exclusionTypeMessages = (site: Site) => {
  switch (site) {
    case Site.FR:
      return {
        [ExclusionType.SelfExclusion]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        }
      };
    case Site.USPA:
      return {
        [ExclusionType.Break]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        },
        [ExclusionType.SelfExclusion]: {
          submit: TXTCLI_Confirm
        }
      };
    case Site.USNJ:
      return {
        [ExclusionType.Break]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        },
        [ExclusionType.SelfExclusion]: {
          submit: TXTCLI_Confirm
        }
      };
    case Site.GR:
      return {
        [ExclusionType.SelfExclusion]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        },
        [ExclusionType.Break]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        },
        [ExclusionType.PermanentSelfExclusion]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTCLI_Confirm
        }
      };
    default:
      return {
        [ExclusionType.Break]: {
          reopenAccount: TXTWCL_WeXll_automatically_reopen_you_ELL,
          submit: TXTWCL_Confirm_your_break
        },
        [ExclusionType.SelfExclusion]: {
          reopenAccount: TXTWCL_YouXll_be_able_to_request_to_r_ELL,
          submit: TXTWCL_Confirm_your_self_exclusion
        },
        [ExclusionType.ShortTermDE]: {
          submit: TXTCLI_Confirm
        },
        [ExclusionType.LongTermDE]: {
          submit: TXTCLI_Confirm
        }
      };
  }
};

export const exclusionTypeTimeoutsIT = {
  [SelfExclusion.Brand]: {
    [ExclusionType.Break]: [-12, 1, 7, 30, 60, 90, 120],
    [ExclusionType.SelfExclusion]: [0]
  },
  [SelfExclusion.Nationally]: {
    [ExclusionType.Break]: [30, 60, 90],
    [ExclusionType.SelfExclusion]: [0]
  }
};
